import { TSubmitValues } from "backend/datainput";
import { ICardElementWithChildren } from "backend/model/model";
import * as types from "client-api-workflow/types";
import ValueInputForm from "design/components/forms/ValueInputForm";
import { t } from "i18next";
import React from "react";

const InitiativeApproveForm = (props: {
  initiative: ICardElementWithChildren;
  childElements: ICardElementWithChildren[];
  comments?: types.WFComment[];
  attachments?: types.FileValue[];
  onSubmit?: (value: TSubmitValues) => void;
  canReject?: boolean;
  canApprove?: boolean;
}) => {
  const {
    initiative,
    childElements,
    attachments,
    comments,
    canReject,
    canApprove,
  } = props;

  return (
    <ValueInputForm
      key={initiative?.workflowInstance?.wfInstanceId}
      element={initiative!}
      childElements={childElements}
      fields={[
        {
          title: t("workflowinput.form.Attachments"),
          element: initiative,
          inputType: "attachments",
          initialFiles: attachments,
          isDisabled: !(
            initiative?.workflowInstance?.allowedActions.includes(
              "editdocuments"
            ) === true
          ),
        },
        {
          title: t("workflowinput.form.Actions and Recommendations"),
          element: initiative,
          inputType: "comment",
          isDisabled: !(
            initiative?.workflowInstance?.allowedActions.includes(
              "editcomments"
            ) === true
          ),
          comments: comments,
          initialValue: comments && comments[0] ? comments[0].description : "",
        },
        {
          title: t("workflowinput.form.Approval or Rejection message"),
          series: "MESSAGE" as any,
          initialValue: "",
          fullWidth: true,
          element: initiative,
          inputType: "string",
          validate: (value) => {
            if (!value.field.value) {
              return {
                success: false,
                errorMessages: [
                  t(
                    "workflowinput.form.errors.Approval or Rejection Message must be Given"
                  ),
                ],
              };
            }
            return {
              success: true,
            };
          },
        },
      ]}
      buttons={[
        {
          tag: "approve",
          style: "approve",
          text: t("workflowinput.form.Approve"),
          isDisabled: !canApprove,
          onClick: (fields) => {
            if (props.onSubmit) {
              props.onSubmit({
                fields: fields,
                message: fields
                  .filter((v) => v.series === "MESSAGE")
                  .map((f) => f.value)
                  .join(""),
                transition: "APPROVE",
              });
            }
          },
        },
        {
          tag: "reject",
          style: "reject",
          text: t("workflowinput.form.Reject"),
          isDisabled: !canReject,
          onClick: (fields) => {
            if (props.onSubmit) {
              props.onSubmit({
                fields: fields,
                message: fields
                  .filter((v) => v.series === "MESSAGE")
                  .map((f) => f.value)
                  .join(""),
                transition: "REJECT",
              });
            }
          },
        },
      ]}
    />
  );
};

export default InitiativeApproveForm;
